module.exports = __webpack_public_path__ + "static/media/Scarf_Bones_02.3526d8fc.png";